import { LogoutService } from './../user-repository/logout.service';
import { ExerciseData } from './../../../core/model/object/exercise-model';
import {
  ResponseDayExerciseLogs,
  ResponseDayLogs,
} from './../../../core/model/api-response/plans-response-model';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { UserDataService } from './../user-repository/user-data.service';
import { GenericResponse } from 'src/app/data/repository/generic-response';
import { Injectable } from '@angular/core';
import { ExerciseItem } from 'src/app/core/model/api-response/plans-response-model';

@Injectable({
  providedIn: 'root',
})
export class ExerciseLogService {
  constructor(
    private dbService: NgxIndexedDBService,
    private logoutService: LogoutService
  ) {}
  private calendarSharedTime: number = new Date(
    new Date().setHours(0, 0, 1, 0)
  ).getTime();
  public get CDate(): number {
    return this.calendarSharedTime;
  }
  public set CDate(date: number) {
    this.calendarSharedTime = date;
  }
  public async getDayExercises(date: number): Promise<ExerciseData> {
    let exerciseLogs: ResponseDayExerciseLogs[] = [];
    let exerciseDayData: ExerciseData;
    const response = await this.dbService
      .getByIndex('exerciseLogs', 'date', date)
      .then(
        async (fls) => {
          if (fls && fls.exerciseLogs) {
            exerciseLogs = [];
            fls['exerciseLogs'].forEach((fl, i) => {
              const f = new ResponseDayExerciseLogs(
                fl['calorie'],
                fl['createdAt'],
                fl['date'],
                fl['deleted'],
                fl['duration'],
                fl['name'],
                fl['updatedAt'],
                fl['user'],
                fl['_id'],
                fl['exercise']
              );
              exerciseLogs.push(f);
            });
            const exerciseLogsUpdatedAt = fls['updatedAt'];
            exerciseDayData = new ExerciseData(
              date,
              exerciseLogs,
              exerciseLogsUpdatedAt
            );
          } else {
            exerciseDayData = null;
          }
          return exerciseDayData;
        },
        (error) => {
          this.logoutService.logout();
          return new ExerciseData(null, null, null);
        }
      );
    return Promise.resolve(response);
  }

  public async saveExerciseLogs(
    res: ResponseDayExerciseLogs[],
    date: number
  ): Promise<boolean> {
    const fls = await this.dbService.getByIndex('exerciseLogs', 'date', date);
    let response = true;
    if (fls) {
      response = await this.dbService
        .update('exerciseLogs', {
          id: fls['id'],
          exerciseLogs: res ? res : fls['exerciseLogs'],
          date,
          updatedAt: new Date().getTime(),
        })
        .then(
          () => {
            return true;
          },
          (error) => {
            console.log(error);
            return false;
          }
        );
    } else {
      response = await this.dbService
        .add('exerciseLogs', {
          exerciseLogs: res,
          date,
          updatedAt: new Date().getTime(),
        })
        .then(
          () => {
            return true;
          },
          (error) => {
            console.log(error);
            return false;
          }
        );
    }
    return Promise.resolve(response);
  }

  public async updateExerciseLogs(
    res: ResponseDayExerciseLogs[],
    date: number
  ): Promise<boolean> {
    let response = true;

    const fls = await this.dbService.getByIndex('exerciseLogs', 'date', date);
    if (fls) {
      res.forEach((exerciseLog) => {
        let found = false;
        fls['exerciseLogs'].forEach((f, i) => {
          if (exerciseLog._id === f._id) {
            found = true;
            fls['exerciseLogs'][i] = exerciseLog;
          }
        });
        if (!found) {
          fls['exerciseLogs'].push(exerciseLog);
        }
      });
      fls['id'];
      response = await this.dbService
        .update('exerciseLogs', {
          id: fls['id'],
          exerciseLogs: fls['exerciseLogs'],
          date,
          updatedAt: new Date().getTime() + 1000,
        })
        .then(
          () => {
            return true;
          },
          (error) => {
            return false;
          }
        );
    } else {
      response = await this.dbService
        .add('exerciseLogs', {
          exerciseLogs: res,
          date,
          updatedAt: new Date().getTime() + 1000,
        })
        .then(
          () => {
            return true;
          },
          (error) => {
            console.log(error);
            return false;
          }
        );
    }
    return Promise.resolve(response);
  }

  public async removeExerciseLogs(
    date: number,
    exerciseLogs: ResponseDayExerciseLogs[]
  ): Promise<boolean> {
    let response = true;
    let updated = false;
    const fls = await this.dbService.getByIndex('exerciseLogs', 'date', date);
    exerciseLogs.forEach((foodLog) => {
      fls['exerciseLogs'].forEach((f, i) => {
        if (foodLog === f._id) {
          updated = true;
          fls['exerciseLogs'].splice(i, 1);
        }
      });
    });
    response = await this.dbService
      .update('exerciseLogs', {
        id: fls['id'],
        exerciseLogs: fls['exerciseLogs'],
        date,
        updatedAt: new Date().getTime(),
      })
      .then(
        () => {
          return updated;
        },
        (error) => {
          return false;
        }
      );
    return Promise.resolve(response);
  }

  public async removeSignleExerciseLogs(
    date: number,
    ids: string[]
  ): Promise<boolean> {
    let response = true;
    let updated = false;
    const fls = await this.dbService.getByIndex('exerciseLogs', 'date', date);
    ids.forEach((foodLog) => {
      fls['exerciseLogs'].forEach((f, i) => {
        if (foodLog === f._id) {
          updated = true;
          fls['exerciseLogs'].splice(i, 1);
        }
      });
    });
    response = await this.dbService
      .update('exerciseLogs', {
        id: fls['id'],
        exerciseLogs: fls['exerciseLogs'],
        date,
        updatedAt: new Date().getTime(),
      })
      .then(
        () => {
          return updated;
        },
        (error) => {
          console.log(error);
          return false;
        }
      );
    return Promise.resolve(response);
  }
}
